import user1 from '../assets/img/ourStaff/1.jpg';
import user2 from '../assets/img/ourStaff/2.jpg';
import user3 from '../assets/img/ourStaff/3.jpg';
import user81824 from '../assets/img/ourStaff/81824.jpg';
import user204643 from '../assets/img/ourStaff/204643.jpg';
import user409496 from '../assets/img/ourStaff/409496.png';
import user585785 from '../assets/img/ourStaff/585785.png';
import user662523 from '../assets/img/ourStaff/662523.png';
import user1516530 from '../assets/img/ourStaff/1516530.jpg';
import user39239 from '../assets/img/ourStaff/39239.png';

export default {
    mpg_user_1: {
        id: 'mpg_user_1',
        firstName: 'Grégory',
        lastName: 'Rota',
        mainPlatform: 'mpg',
        title: 'Pruner climber',
        picture: user1
    },
    mpg_user_2: {
        id: 'mpg_user_2',
        firstName: 'Benjamin',
        lastName: 'Fouquet',
        mainPlatform: 'mpg',
        title: 'Plant breeder',
        picture: user2
    },
    mpg_user_3: {
        id: 'mpg_user_3',
        firstName: 'Martin',
        lastName: 'Jaglin',
        mainPlatform: 'mpg',
        title: 'Landscape gardener',
        picture: user3
    },
    mpg_user_81824: {
        id: 'mpg_user_81824',
        firstName: 'Maxime',
        lastName: 'Gutierrez',
        mainPlatform: 'mgd',
        title: 'Community manager - Spain',
        picture: user81824
    },
    mpg_user_204643: {
        id: 'mpg_user_204643',
        firstName: 'Jean-Baptiste',
        lastName: 'Griveaud',
        mainPlatform: 'mpg',
        title: 'Community manager - France',
        picture: user204643
    },
    mpg_user_409496: {
        id: 'mpg_user_409496',
        firstName: 'Nicolas',
        lastName: 'Rouvière',
        mainPlatform: 'mpg',
        title: 'Apprentice gardener',
        picture: user409496
    },
    mpg_user_585785: {
        id: 'mpg_user_585785',
        firstName: 'Baptiste',
        lastName: 'Garcin',
        mainPlatform: 'mpg',
        title: 'Apprentice gardener',
        picture: user585785
    },
    mpg_user_662523: {
        id: 'mpg_user_662523',
        firstName: 'Benoit',
        lastName: 'Corbel',
        mainPlatform: 'mpg',
        title: 'Apprentice gardener',
        picture: user662523
    },
    mpg_user_1516530: {
        id: 'mpg_user_1516530',
        firstName: 'Louis',
        lastName: 'Ponnelle',
        mainPlatform: 'mpg',
        title: 'Apprentice gardener',
        picture: user1516530
    },
    mpg_user_949520: {
        id: 'mpg_user_949520',
        firstName: 'Theophile',
        lastName: 'Catin',
        mainPlatform: 'mpg',
        title: 'Suceur de noeud',
        picture: user1516530
    },
    mpg_user_39239: {
      id: 'mpg_user_39239',
      firstName: 'Xavier',
      lastName: 'Villelégier',
      mainPlatform: 'mpg',
      title: 'Apprentice gardener',
      picture: user39239
    }
};



// WEBPACK FOOTER //
// ./src/helpers/ourStaff.js